import {
    FileFormats, FormFieldTypes, ImageFormats,
    validationTypes
} from "@repo/design-system/components/forms/libs";

export const PageHeaderConfig = (t) => ({
    name: "Page Header",
    initialState: { search: "" },
    section: [
        {
            title: "Page Header Section",
            row: {},
            style: {
                sectionStyle: "page-header-config",
            },
            rowGroup: [
                {
                    groupLabel: "User Information",
                    style: {
                        groupStyle: "",
                    },
                    fields: [
                        {
                            id: "search",
                            label: "",
                            Field_Name: "search",
                            fieldType: FormFieldTypes.INPUT,
                            dataField: "search",
                            fieldSetting: {
                                placeholder: "Search",
                                // iconConfig: {
                                //     icon: "icon-park-outline:search",
                                //     // ttLabel: "Time",
                                //     // targetId: "time",
                                //     // width: 30
                                // },

                            },
                            // validation: [{ type: validationTypes.REQUIRE }],
                            style: {
                                containerCss: "grid-search-bar"
                            }
                        }
                    ]
                },
            ],
        }
    ]
});